export const TYPE = 'type'
export const VENDOR = 'vendor'
export const PART_NUMBER = 'partNumber'
export const DETAILS = 'details'